module.exports = __webpack_public_path__ + "rosywhitey.jpg?4830f8e9bbf12da09629a51894ab2b7c";


//////////////////
// WEBPACK FOOTER
// ./public/creator-avatar/rosywhitey.jpg
// module id = 715
// module chunks = 0